import React from 'react'

const AboutSection = () => {
  return (
    
    <div className='  bg-about-img bg-center bg-cover py-[60px] px-[50px] bg-blend-lighten'>
        {/* <img src="/assets/aboutimg.png"/> */}
        <div className='flex justify-center items-center flex-col md:flex-row'>
        <div className=' flex-1'>
        <div className='px-5'>
        <h3  className="text-transparent uppercase bg-clip-text bg-gradient-to-t from-[#6f30fd] to-[#45adf4] text-3xl font-bold " >About ICO</h3>
        <h2 className='uppercase md:text-3xl text-2xl font-bold py-5'>MAXIMIZE PROFITS WITH $LRN: RIDE THE WAVE OF AI GENERATED HUMAN DEVELOPMENT!</h2>
        <p className='mb-5 font-thin text-[#ffffff]'>Staking $LRN earns the metaverse currency at 20% APY: $LEARN, which is pegged at USD0.10 and is used to buy NFTs for Memberships, Offices, Mall Shops, Event Spaces, Advertising, Personal AIs, Buildings, International Certifications, Time with Global Thought Leaders, Access to Elite Members of the Community, Professional Consulting, Coaching or Workshops… and more</p>
        <p className='text-[#ffffff] font-thin'><span>$LRN increases in value as tokens are burned. Each new member that joins the Global Mentor Exchange, burns 100 tokens reducing the overall supply</span></p>
        </div>
        
     </div>
     <div className='flex-1'>
        <img src={process.env.PUBLIC_URL +'/assets/about.png'}/>
     </div>
        </div>
     
    </div>
  )
}

export default AboutSection
